import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import {
    PatentDraftExampleService,
    PatentDraftExampleServiceImpl,
} from './services/patent-draft-example-service';

export const patentDraftContainer = new ContainerModule((bind) => {
    bind(PatentDraftExampleService).to(PatentDraftExampleServiceImpl);
});
